module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.editModus && !_vm.kombox.id) ? [_c('div', {
    staticClass: "media-body media-right text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "title": "Neuer Eintrag",
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editModus = true
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  })])])] : _vm._e(), _vm._v(" "), (!_vm.editModus && _vm.kombox.id) ? [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-body",
    on: {
      "dblclick": function($event) {
        _vm.editModus = true
      }
    }
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left media-middle",
    attrs: {
      "title": _vm.KomboxConf.TYPES[_vm.kombox.type].SYMBOL.TITLE
    }
  }, [_c('span', {
    staticClass: "glyphicon",
    class: [_vm.KomboxConf.TYPES[_vm.kombox.type].SYMBOL.CLASS, _vm.KomboxConf.ACLS[_vm.kombox.acl].SYMBOL.CLASS]
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body cc-kombox-body  media-middle"
  }, [(_vm.kombox.acl == 3) ? _c('strong', {
    attrs: {
      "title": _vm.kombox.content
    }
  }, [_vm._v("*******")]) : _c('strong', [_vm._v(_vm._s(_vm.kombox.content))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.kombox.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "media-right text-right media-middle"
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editModus = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "btn btn-xs btn-default",
    class: {
      'btn-success': _vm.shippingAktive
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onClickShipping
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-send"
  })])])])] : _vm._e(), _vm._v(" "), (_vm.editModus) ? _c('cc-kombox-form', {
    attrs: {
      "kombox": _vm.kombox
    },
    on: {
      "cancel": _vm.cancel,
      "remove": _vm.remove,
      "save": _vm.save
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50a517db!./~/vue-loader/lib/selector.js?type=template&index=0!./src/KomboxUserCaller.vue
// module id = 275
// module chunks = 0